import _ from 'lodash';
import getImages from '../../../utils/GetImages';

const mapMainVariant = ({ product }) => {
  const { id, name = '', variants = [], quantity } = product;
  const currentVariant = _.find(variants, { id: product.currentVariant });
  const medias = _.get(currentVariant, 'medias', []);
  const image = getImages({
    url: _.get(medias[0], 'url', ''),
    isCFMediasEnabled: true,
    attr: {
      width: 50,
      height: 50,
    },
  });
  return { id, name, image, quantity };
};

export { mapMainVariant };
